<div class="status-card">
  <div class="header">
    <div class="title">{{ title }}</div>
    <div class="status" [ngClass]="statusClass">{{ statusText }}</div>
  </div>
  <div class="content">
    <div class="info-box" [class]="statusClass" *ngIf="infoBoxMessage">
      <div class="info-box-icon">
        <ion-icon class="icon-document" name="document-text"></ion-icon>
      </div>
      <div class="info-box-message">
        <div class="title">Conoce el estado de tu trámite</div>
        <p>{{ infoBoxMessage }}</p>
      </div>
    </div>
    <div class="details" *ngIf="details.length > 0">
      <div class="details-card" *ngFor="let item of details">
        <div class="detail-item" *ngIf="!item.isHeader">
          <span>{{ item.label }}:</span>
          <span>{{ item.value }}</span>
        </div>
        <div class="detail-item-payment" *ngIf="item.isHeader"><strong>{{ item.label }}</strong> </div>
      </div>
    </div>
    <div class="details skeleton-box" *ngIf="hayDetails && details.length === 0">
      <ion-skeleton-text animated style="width: 40%; height: 14px"></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 70%; height: 14px; margin-top: 10px"></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 50%; height: 14px; margin-top: 10px"></ion-skeleton-text>
    </div>
    <div class="disponible-pago" *ngIf="details.length === 0 && infoImportant">
      <p *ngIf="!esCompaniaSeguro">Desde ahora puedes acceder a la información de pago de tu pensión, como monto, fechas
        y medio de pago. </p>
      <p *ngIf="esCompaniaSeguro">Puedes acceder a la información de pago en la Compañía de Seguros que elegiste para
        administrar tu pensión.</p>
      <div class="disponible-pago-button" *ngIf="!esCompaniaSeguro">
        <button (click)="goToPagoPension()">Ir a Información pago de pensión</button>
      </div>
    </div>
    <div class="info-icon-text" [class.ion-margin-bottom-text]="infoText && (infoImportant || requestTitle)"
      *ngIf="infoText">
      <div class="icon">
        <img src="/assets/contactotdp/icons/info.svg" alt="info">
      </div>
      <p>{{ infoText }}</p>
    </div>

    <div *ngIf="tieneCertificadoSaldos">
      <div class="button-generic">
        <button (click)="goToModalDescargaCertificado()">Ir a descarga certificado</button>
      </div>
    </div>

    <div *ngIf="tieneCertificadoOfertas">
      <div class="button-generic">
        <button (click)="descargarCertificadoOfertas.emit()">Ir a descargar certificado</button>
      </div>
    </div>
    <div class="info-important-text" *ngIf="infoImportant">
      <h3>{{ requestTitleImportant }}</h3>
      <p>{{ infoImportant }} <strong *ngIf="infoImportantStrong">{{infoImportantStrong}}</strong></p>
      <p *ngIf="requestDescriptionInfoImportant">
        {{ requestDescriptionInfoImportant }}
        <a href="{{ requestLink }}"> {{ requestLinkText }}</a> {{ !tieneCertificadoOfertas ? 'o en alguna de nuestras
        sucursales.' : '' }}
      </p>

    </div>
    <div class="info-important-text" *ngIf="tieneCertificadoSaldos && infoImportantInnerHTML">
      <h3>{{ requestTitleImportant }}</h3>
      <p [innerHTML]="infoImportantInnerHTML"></p>

    </div>
    <div class="request-section" *ngIf="requestTitle">
      <h3>{{ requestTitle }}</h3>
      <p>
        {{ requestDescription }}
        <a href="{{ requestLink }}"> {{ requestLinkText }}</a> o en alguna de
        nuestras sucursales.
      </p>
    </div>
  </div>
</div>